import { browser } from "$app/env";

export type ToastKind = "good" | "warning" | "critical";

interface ToastAction {
  readonly label: string;
  readonly run: () => void;
}

export interface ToastOptions {
  readonly signIn?: boolean;
  readonly action?: ToastAction;
}

type ToastEntry = {
  id: number;
  kind: ToastKind;
  message: string;
  signIn: boolean;
  action: ToastAction | null;
};

const TOAST_LIFETIME_MS = 5000;

let next = 0;

const queue = $state({ entries: [] as ToastEntry[] });

export const toasts = (): readonly ToastEntry[] => queue.entries;

export const dismissToast = (id: number): void => {
  queue.entries = queue.entries.filter((entry) => entry.id !== id);
};

export const toast = (kind: ToastKind, message: string, options: ToastOptions = {}): number => {
  if (!browser) return -1;
  const shown = queue.entries.find((entry) => entry.kind === kind && entry.message === message);
  if (shown !== undefined) return shown.id;
  const id = next++;
  queue.entries = [
    ...queue.entries,
    {
      id,
      kind,
      message,
      signIn: options.signIn === true,
      action: options.action === undefined ? null : options.action,
    },
  ];
  setTimeout(() => dismissToast(id), TOAST_LIFETIME_MS);
  return id;
};
